import { render, staticRenderFns } from "./Co52Page.vue?vue&type=template&id=79a984e0"
import script from "./Co52Page.vue?vue&type=script&lang=js"
export * from "./Co52Page.vue?vue&type=script&lang=js"
import style0 from "./Co52Page.vue?vue&type=style&index=0&id=79a984e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports